module.exports = __webpack_public_path__ + "static/img/about-02.5441b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-02.png
// module id = kGK0
// module chunks = 0